import { DATE_FORMATS } from "@/enums";
import { getProjectStatusLabelFromId } from "@/helpers/getProjectStatusLabelFromId";
import { IProject } from "@/interfaces";
import { useGetProjectStatusHistoryQuery, useGetUserQuery } from "@/services";
import { FlexDiv } from "@/sharedStyled";
import { Card, Spin, Steps, Typography } from "antd";
import dayjs from "dayjs";
import { useIntl } from "react-intl";

interface IProps {
  intakeData: IProject;
}

const { Text } = Typography;

export const ProjectIntakeStatusTracker = ({ intakeData }: IProps) => {
  const { data, isFetching: isLoadingData } = useGetProjectStatusHistoryQuery({
    projectId: intakeData.id,
    statusId: intakeData.status,
  });
  const { data: user, isFetching: isLoadingUser } = useGetUserQuery(
    data?.updatedBy,
    { skip: !data?.updatedBy }
  );
  const intl = useIntl();

  return (
    <Card className="w-full">
      <FlexDiv>
        <Text>
          {intl.formatMessage({
            id: "projectIntake.intakeApprovalStatus",
          })}
        </Text>
        {isLoadingUser || isLoadingData ? (
          <Spin />
        ) : (
          <Steps
            status="error"
            items={[
              {
                title: intl.formatMessage({
                  id: getProjectStatusLabelFromId(intakeData.status),
                }),
                description: `${user?.displayName} on ${dayjs(
                  data?.updatedAt
                )?.format(DATE_FORMATS.twoDigitYear)}`,
              },
            ]}
          />
        )}
      </FlexDiv>
    </Card>
  );
};
